package com.devi3east.bashbuddy

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String
import kotlin.collections.List

public class FavoriteRecipeQueries(
  driver: SqlDriver,
  private val RecipeAdapter: Recipe.Adapter,
) : SuspendingTransacterImpl(driver) {
  public fun selectAllFavoritesRecipeIds(): Query<Long> = Query(1_291_929_753,
      arrayOf("FavoriteRecipe"), driver, "FavoriteRecipe.sq", "selectAllFavoritesRecipeIds",
      "SELECT id FROM FavoriteRecipe") { cursor ->
    cursor.getLong(0)!!
  }

  public fun <T : Any> selectAllFavoritesRecipes(mapper: (
    id: Long,
    title: String,
    description: String,
    category: String,
    area: String,
    imageUrl: String,
    youtubeLink: String,
    ingredients: List<String>,
    instructions: List<String>,
    isFavorite: Long,
    rating: Long,
    duration: String?,
    difficulty: String?,
  ) -> T): Query<T> = Query(-816_531_788, arrayOf("Recipe", "FavoriteRecipe"), driver,
      "FavoriteRecipe.sq", "selectAllFavoritesRecipes",
      "SELECT Recipe.id, Recipe.title, Recipe.description, Recipe.category, Recipe.area, Recipe.imageUrl, Recipe.youtubeLink, Recipe.ingredients, Recipe.instructions, Recipe.isFavorite, Recipe.rating, Recipe.duration, Recipe.difficulty FROM Recipe INNER JOIN FavoriteRecipe ON Recipe.id = FavoriteRecipe.recipe_id") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      RecipeAdapter.ingredientsAdapter.decode(cursor.getString(7)!!),
      RecipeAdapter.instructionsAdapter.decode(cursor.getString(8)!!),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getString(11),
      cursor.getString(12)
    )
  }

  public fun selectAllFavoritesRecipes(): Query<Recipe> = selectAllFavoritesRecipes { id, title,
      description, category, area, imageUrl, youtubeLink, ingredients, instructions, isFavorite,
      rating, duration, difficulty ->
    Recipe(
      id,
      title,
      description,
      category,
      area,
      imageUrl,
      youtubeLink,
      ingredients,
      instructions,
      isFavorite,
      rating,
      duration,
      difficulty
    )
  }

  public fun <T : Any> selectFavoriteByRecipeId(recipe_id: Long, mapper: (
    id: Long,
    recipe_id: Long,
    added_at: String,
  ) -> T): Query<T> = SelectFavoriteByRecipeIdQuery(recipe_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getString(2)!!
    )
  }

  public fun selectFavoriteByRecipeId(recipe_id: Long): Query<FavoriteRecipe> =
      selectFavoriteByRecipeId(recipe_id) { id, recipe_id_, added_at ->
    FavoriteRecipe(
      id,
      recipe_id_,
      added_at
    )
  }

  public suspend fun insertFavorite(recipe_id: Long, added_at: String) {
    driver.execute(-1_242_796_332, """
        |INSERT INTO FavoriteRecipe(recipe_id, added_at)
        |VALUES(?, ?)
        """.trimMargin(), 2) {
          bindLong(0, recipe_id)
          bindString(1, added_at)
        }.await()
    notifyQueries(-1_242_796_332) { emit ->
      emit("FavoriteRecipe")
    }
  }

  public suspend fun detelteFavoriteByRecipeById(recipe_id: Long) {
    driver.execute(105_362_815, """DELETE FROM FavoriteRecipe WHERE recipe_id = ?""", 1) {
          bindLong(0, recipe_id)
        }.await()
    notifyQueries(105_362_815) { emit ->
      emit("FavoriteRecipe")
    }
  }

  public suspend fun deleteAllFavoriteRecipes() {
    driver.execute(1_364_997_426, """DELETE FROM FavoriteRecipe""", 0).await()
    notifyQueries(1_364_997_426) { emit ->
      emit("FavoriteRecipe")
    }
  }

  public suspend fun upsertFavorite(added_at: String, recipe_id: Long) {
    transaction {
      driver.execute(857_297_019, """
          |UPDATE FavoriteRecipe
          |    SET added_at = ?
          |    WHERE recipe_id = ?
          """.trimMargin(), 2) {
            bindString(0, added_at)
            bindLong(1, recipe_id)
          }.await()
      driver.execute(857_297_020, """
          |INSERT OR IGNORE INTO FavoriteRecipe(recipe_id, added_at)
          |   VALUES(?, ?)
          """.trimMargin(), 2) {
            bindLong(0, recipe_id)
            bindString(1, added_at)
          }.await()
    }
    notifyQueries(693_628_746) { emit ->
      emit("FavoriteRecipe")
    }
  }

  private inner class SelectFavoriteByRecipeIdQuery<out T : Any>(
    public val recipe_id: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("FavoriteRecipe", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("FavoriteRecipe", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_334_462_921,
        """SELECT FavoriteRecipe.id, FavoriteRecipe.recipe_id, FavoriteRecipe.added_at FROM FavoriteRecipe WHERE recipe_id = ?""",
        mapper, 1) {
      bindLong(0, recipe_id)
    }

    override fun toString(): String = "FavoriteRecipe.sq:selectFavoriteByRecipeId"
  }
}
